import React, { useState } from "react";
import { Download, Package, Info } from "lucide-react";
import toast from "react-hot-toast";

const SOFTWARE_INFO = {
  name: "PipoClient",
  version: "1.0.0",
  size: "~15 MB",
};

const DOWNLOAD_URL = "/PipoClient.zip";

export default function DownloadPage() {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = () => {
    setDownloading(true);
    toast.success("Download dimulai...");
    const a = document.createElement("a");
    a.href = DOWNLOAD_URL;
    a.download = "PipoClient.zip";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => setDownloading(false), 3000);
  };

  return (
    <div style={s.page}>
      <div style={s.header}>
        <h1 style={s.title}>Download Software</h1>
        <p style={s.sub}>Download PipoClient untuk customer</p>
      </div>

      <div style={s.grid}>
        {/* Card kiri */}
        <div style={s.card}>
          <div style={s.cardIcon}><Package size={40} color="#6366f1" /></div>
          <h2 style={s.cardTitle}>{SOFTWARE_INFO.name}</h2>
          <p style={s.cardVersion}>v{SOFTWARE_INFO.version}</p>

          <div style={s.infoGrid}>
            <div style={s.infoItem}>
              <span style={s.infoLabel}>Format</span>
              <span style={s.infoVal}>ZIP Archive</span>
            </div>
            <div style={s.infoItem}>
              <span style={s.infoLabel}>Platform</span>
              <span style={s.infoVal}>Windows x64</span>
            </div>
            <div style={s.infoItem}>
              <span style={s.infoLabel}>Ukuran</span>
              <span style={s.infoVal}>{SOFTWARE_INFO.size}</span>
            </div>
            <div style={s.infoItem}>
              <span style={s.infoLabel}>Versi</span>
              <span style={s.infoVal}>{SOFTWARE_INFO.version}</span>
            </div>
          </div>

          {/* Isi ZIP */}
          <div style={s.zipBox}>
            <div style={s.zipTitle}>📦 Isi ZIP:</div>
            {[
              ["PipoClient.exe", "Program utama"],
              ["akun.txt",       "Daftar akun (email|password|link)"],
              ["data.txt",       "DANA (nomor|pin)"],
              ["proxy.txt",      "Proxy (opsional)"],
              ["README.md",      "Panduan penggunaan"],
            ].map(([f, d]) => (
              <div key={f} style={s.zipRow}>
                <span style={s.zipFile}>{f}</span>
                <span style={s.zipDesc}>{d}</span>
              </div>
            ))}
          </div>

          <button onClick={handleDownload} disabled={downloading} style={s.dlBtn}>
            <Download size={18} />
            {downloading ? "Downloading..." : "Download PipoClient.zip"}
          </button>
        </div>

        {/* Card kanan — instruksi */}
        <div style={s.infoCard}>
          <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:16 }}>
            <Info size={18} color="#6366f1" />
            <h3 style={{ color:"#fff", margin:0, fontSize:15, fontWeight:600 }}>Cara Penggunaan</h3>
          </div>

          <ol style={s.steps}>
            {[
              <>Download & extract <b>PipoClient.zip</b></>,
              <>Jalankan <b>PipoClient.exe</b> — muncul <b style={{color:"#f87171"}}>HWID</b></>,
              <>Kirim HWID ke admin untuk didaftarkan</>,
              <>Admin buat license key → kirim ke customer</>,
              <>Isi <b>akun.txt</b>: format <code style={s.code}>email|password|link</code></>,
              <>Isi <b>data.txt</b>: format <code style={s.code}>nomor|pin</code> (DANA)</>,
              <>Input license key di .exe → jalankan</>,
            ].map((step, i) => (
              <li key={i} style={s.step}>
                <span style={s.stepNum}>{i+1}</span>
                <span>{step}</span>
              </li>
            ))}
          </ol>

          <div style={s.noteBlue}>
            <div style={{ color:"#a5b4fc", fontWeight:600, marginBottom:6 }}>📄 Format akun.txt:</div>
            <pre style={s.pre}>{`# email|password|link\nuser@gmail.com|pass123|https://cashier-my4a.pipopay.com/...\nuser2@gmail.com|mypass|https://cashier-my4a.pipopay.com/...`}</pre>
          </div>

          <div style={{ ...s.noteBlue, marginTop:10 }}>
            <div style={{ color:"#a5b4fc", fontWeight:600, marginBottom:6 }}>📱 Format data.txt (DANA):</div>
            <pre style={s.pre}>{`# nomor|pin\n085612345678|123456\n081298765432|654321`}</pre>
          </div>

          <div style={{ ...s.noteYellow, marginTop:10 }}>
            <span style={{ color:"#f59e0b", fontWeight:600 }}>⚠ Note: </span>
            <span style={{ color:"#94a3b8" }}>1 license key hanya bisa dipakai di 1 PC (HWID locked)</span>
          </div>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:      { padding:"32px 32px 32px 252px", minHeight:"100vh", fontFamily:"'Segoe UI',sans-serif" },
  header:    { marginBottom:28 },
  title:     { color:"#fff", fontSize:24, fontWeight:700, margin:0 },
  sub:       { color:"#64748b", fontSize:13, marginTop:4 },
  grid:      { display:"grid", gridTemplateColumns:"360px 1fr", gap:20, alignItems:"start" },
  card:      { background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.1)", borderRadius:16, padding:28, textAlign:"center" },
  cardIcon:  { background:"rgba(99,102,241,0.12)", borderRadius:"50%", width:72, height:72, display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 14px", border:"1px solid rgba(99,102,241,0.3)" },
  cardTitle: { color:"#fff", fontSize:20, fontWeight:700, margin:"0 0 4px" },
  cardVersion:{ color:"#6366f1", fontSize:13, margin:"0 0 16px", fontWeight:600 },
  infoGrid:  { display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, marginBottom:16 },
  infoItem:  { background:"rgba(255,255,255,0.04)", borderRadius:8, padding:"8px 10px", textAlign:"left" },
  infoLabel: { display:"block", color:"#64748b", fontSize:11, marginBottom:2 },
  infoVal:   { display:"block", color:"#e2e8f0", fontSize:12, fontWeight:500 },
  zipBox:    { background:"rgba(99,102,241,0.08)", border:"1px solid rgba(99,102,241,0.2)", borderRadius:8, padding:12, marginBottom:16, textAlign:"left" },
  zipTitle:  { color:"#a5b4fc", fontSize:12, fontWeight:600, marginBottom:8 },
  zipRow:    { display:"flex", justifyContent:"space-between", padding:"3px 0" },
  zipFile:   { fontFamily:"monospace", fontSize:12, color:"#e2e8f0" },
  zipDesc:   { color:"#64748b", fontSize:11 },
  dlBtn:     { width:"100%", padding:"13px 0", background:"linear-gradient(135deg,#6366f1,#8b5cf6)", border:"none", borderRadius:10, color:"#fff", fontSize:14, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:8 },
  infoCard:  { background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.08)", borderRadius:16, padding:24 },
  steps:     { listStyle:"none", padding:0, margin:"0 0 16px", display:"flex", flexDirection:"column", gap:8 },
  step:      { display:"flex", alignItems:"center", gap:10, color:"#cbd5e1", fontSize:13 },
  stepNum:   { minWidth:24, height:24, borderRadius:"50%", background:"rgba(99,102,241,0.2)", border:"1px solid rgba(99,102,241,0.4)", color:"#a5b4fc", fontSize:11, fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center" },
  noteBlue:  { background:"rgba(99,102,241,0.08)", border:"1px solid rgba(99,102,241,0.2)", borderRadius:8, padding:"10px 14px" },
  noteYellow:{ background:"rgba(245,158,11,0.08)", border:"1px solid rgba(245,158,11,0.2)", borderRadius:8, padding:"10px 14px", fontSize:12 },
  code:      { background:"rgba(99,102,241,0.15)", padding:"1px 5px", borderRadius:4, color:"#a5b4fc", fontFamily:"monospace", fontSize:11 },
  pre:       { fontFamily:"monospace", fontSize:11, color:"#94a3b8", lineHeight:1.7, margin:0, whiteSpace:"pre-wrap" },
};
